import App from "@local/App.svelte"

const app = new App({ target: document.body })

export default app
